export enum TabLabelEnum {
  OVERVIEW = 'Overview',
  TECHNICAL_DETAILS = 'Technical details',
  TECHNICAL_DETAILS_MOBILE = 'Details',
  RATINGS_AND_REVIEWS = 'Ratings and reviews',
}
